'use strict';

var robust = require('../util/robust');
var toggle = require('../modules/toggle');
var spotlight = require('../modules/spotlight');
var videoResize = require('../modules/videoResize');
var accordion = require('../modules/accordion');
var messages = require('../modules/messages');
var toggleClass = require('../modules/toggleClass');
var backstagePromo = require('../modules/backstagePromo');
var inlineGallery = require('../modules/inlineGallery');
var scrollTo = require('../modules/scrollTo');
var reviews = require('../modules/reviews');
var productionNav = require('../modules/productionNav');
var newsletterPopup = require('../modules/newsletterPopup');
var eventTracking = require('../modules/eventTracking');
var scrollers = require('../modules/scrollers');
var productionGallery = require('../modules/productionGallery');
var aos = require('../modules/aos');
var escape = require('../modules/escape');
var shorthand = require('../modules/shorthand');
var header = require('../modules/header');
var aoc = require('../modules/aoc');

function init() {
    robust
        .defineModules([
            ['toggle', toggle.init],
            ['spotlight', spotlight.init],
            ['videoResize', videoResize.init],
            ['accordion', accordion.init],
            ['messages', messages.init],
            ['toggleClass', toggleClass.init],
            ['backstagePromo', backstagePromo.init],
            ['inlineGallery', inlineGallery.init],
            ['scrollTo', scrollTo.init],
            ['reviews', reviews.init],
            ['productionNav', productionNav.init],
            ['newsletterPopup', newsletterPopup.init],
            ['eventTracking', eventTracking.init],
            ['scrollers', scrollers.init],
            ['productionGallery', productionGallery.init],
            ['aos', aos.init],
            ['escape', escape.init],
            ['shorthand', shorthand.init],
            ['header', header.init],
            ['aoc', aoc.init]
        ])
        .forEach(function(fn) {
            fn();
        });
}

module.exports = {
    init: init
};
